module.exports = __webpack_public_path__ + "static/gradientTwo-1fd095c0d8edc5dd839d73b1cca7f1d1.svg";